function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgLab = function SvgLab(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19.5,
    fill: "none",
    viewBox: "0 0 12 13"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    d: "M6.284.252a.59.59 0 0 1 .823-.145l4.235 2.964a.592.592 0 0 1-.057 1.004l-1.15.623L5.5 11.32c-.355.506-.892 1.13-1.615 1.457-.777.351-1.689.321-2.645-.348S-.056 10.915.008 10.065c.06-.791.462-1.51.817-2.016zm-4.49 8.475h-.001c-.316.45-.572.955-.608 1.426-.03.412.1.866.73 1.309h.001c.633.443 1.105.41 1.482.24.43-.195.817-.609 1.132-1.059l4.718-6.738.043-.053a.6.6 0 0 1 .16-.127l.43-.234-2.969-2.078z"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    d: "M5.552 5.541c.717-.127 1.55-.28 2.624.039a.59.59 0 1 1-.336 1.132c-.785-.232-1.375-.133-2.08-.007-.717.127-1.55.28-2.625-.038a.591.591 0 0 1 .336-1.133c.785.232 1.375.133 2.081.007"
  }));
};
export default SvgLab;